
@if (ready) {
  <div class="save-indicator" [class.show-save]="showSaveIndicator">
    @switch (storageSaveState) {
      @case ('save_start') { <mat-icon class="pulse">cloud_upload</mat-icon> }
      @case ('save_success') { <mat-icon>cloud_done</mat-icon> }
      @case ('save_error') { <mat-icon>cloud_off</mat-icon> }
      @case ('data_changed') { <mat-icon class="pulse">cloud</mat-icon> }
    }
  </div>
  @if (showChrome()) {
    <div class="atmos-shell">
      <div class="atmos-bg" aria-hidden="true"></div>
      <div class="atmos-vignette" aria-hidden="true"></div>
      <app-topbar class="atmos-topbar-slot"></app-topbar>
      <app-sidebar class="atmos-sidebar-slot"></app-sidebar>
      <main class="atmos-main">
        <router-outlet></router-outlet>
        <app-footer class="atmos-footer-slot"></app-footer>
      </main>
    </div>
  } @else {
    <router-outlet></router-outlet>
  }
}
@else if (err) {
  <app-overlay [dismissable]="false">
    <span>Something went wrong...</span>
    <span>Please report this error.</span>
    <pre class="error-pre" (click)="copy($event)">{{ err }}</pre>
  </app-overlay>
} @else {
  <app-overlay class="loader" [class.loader-loading]="loading" [dismissable]="false">
    <div class="load-body">
      <span>Loading data...</span>
      <mat-icon class="loader-icon">autorenew</mat-icon>
      <a class="atmos-text-link" [routerLink]="'/storage'">Taking too long?</a>
    </div>
  </app-overlay>
}

@if (storageSaveError) {
  <app-overlay [dismissable]="false" [title]="'Saving to storage failed!'">
    <span>The error message is shown below.</span>
    <pre class="save-error-pre">{{ storageSaveError }}</pre>
    <div class="save-error-actions">
      <button class="atmos-btn" type="button" (click)="retrySaveStorage()">
        <mat-icon>sync</mat-icon>
        Retry (force overwrite)
      </button>
      <a class="atmos-btn" [routerLink]="'/storage'">
        <mat-icon>database</mat-icon>
        Return to Storage
      </a>
      <button class="atmos-btn" type="button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh page
      </button>
    </div>
  </app-overlay>
}
